export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const loginRequest = (payload) => ({
  type: LOGIN_REQUEST,
  ...payload,
});

export const loginSuccess = (authData) => ({
  type: LOGIN_SUCCESS,
  authData,
});

export const loginError = () => ({
  type: LOGIN_ERROR,
});

export const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});



// WEBPACK FOOTER //
// ./src/pages/login/actions.js